import VueGoogleMaps from 'vue-google-maps-community-fork'

// leave the export, even if you don't use it
export default ({ app }) => {
  app.use(VueGoogleMaps, {
    load: {
      key: process.env.GOOGLE_API_KEY,
      libraries: 'places'
    },
    installComponents: false,
    autobindAllEvents: true
  })
}
